import React from 'react';
import { LogoutOutlined, UserOutlined } from '@ant-design/icons';
import { signOut } from '@triare/auth-redux/dist/saga/auth/signOut';
import store from '../../../store';

import { Route as BaseRoute } from '../../../routes';

import { IconArrowShewron } from '../../Common/Icon';
import styles from './index.module.scss';

import Home from '../../../pages/Home';
import TippingCategories from '../../../pages/TippingCategories';
import CategoryView from '../../../pages/TippingCategories/[categoryId]';
import ShareYourTwoCents from '../../../pages/ShareYourTwoCents';
import ShareYourTwoCentsView from '../../../pages/ShareYourTwoCents/View';
import CreateNewPost from '../../../pages/ShareYourTwoCents/Create';
import TipCalculator from '../../../pages/TipCalculator';
import TippingArticles from '../../../pages/TippingArticles';
import TippingArticlesView from '../../../pages/TippingArticles/View';
import ArticleByTypeView from '../../../pages/TippingArticles/ByTypeView';
import International from '../../../pages/International';
import Profile from '../../../pages/Profile';
import ProfileEdit from '../../../pages/Profile/Edit';
import Business from '../../../pages/Business';
import CreateAccount from '../../../pages/CreateAccount';
import AccountCreatedSuccessfully from '../../../pages/AccountCreatedSuccessfully';
import TermsAndConditions from '../../../pages/TermsAndConditions';
import PrivacyPolicy from '../../../pages/PrivacyPolicy';
import FAQ from '../../../pages/FAQ';
import OurMission from '../../../pages/OurMission';
import ContactUs from '../../../pages/ContactUs';
import ResetPassword from '../../../pages/Auth/ResetPassword';
import ConfirmEmail from '../../../pages/Auth/ConfirmEmail';

export interface MenuRoute extends BaseRoute {
  ignoreMenu?: boolean;
  children?: MenuRoute[];
}

export const routes: MenuRoute[] = [
  {
    name: 'Home',
    align: 'left',
    route: { path: '/', element: <Home /> },
  },
  {
    name: 'Tipping Categories',
    align: 'left',
    route: { path: 'categories', element: <TippingCategories /> },
    children: [
      {
        name: 'Category View',
        align: 'left',
        ignoreMenu: true,
        route: {
          path: ':categoryId/:subCategoryId?',
          element: <CategoryView />,
        },
      },
    ],
  },
  {
    name: 'Share Your Two Cents',
    align: 'left',
    route: { path: 'share-your-two-cents', element: <ShareYourTwoCents /> },
  },
  {
    name: 'View post',
    ignoreMenu: true,
    route: {
      path: 'share-your-two-cents/:id',
      element: <ShareYourTwoCentsView />,
    },
  },
  {
    privateRoute: true,
    name: 'Create New Post',
    ignoreMenu: true,
    align: 'left',
    route: { path: 'create-new-post', element: <CreateNewPost /> },
  },
  {
    name: 'Tip Calculator',
    align: 'left',
    route: { path: 'tip-calculator', element: <TipCalculator /> },
  },
  {
    name: 'All About Tipping',
    className: 'with-right-chevron',
    icon: <IconArrowShewron className={styles.allAboutIcon} />,
    align: 'left',
    privateRoute: true,
    children: [
      {
        name: 'History of Tipping',
        align: 'left',
        route: {
          path: 'articles/history',
          element: <ArticleByTypeView articleType="history" />,
        },
      },
      {
        name: 'Psychology of Tipping',
        align: 'left',
        route: {
          path: 'articles/psychology',
          element: <ArticleByTypeView articleType="psychology" />,
        },
      },
      {
        name: 'Tipping Articles',
        align: 'left',
        route: { path: 'tipping-articles', element: <TippingArticles /> },
      },
    ],
  },
  {
    name: 'International',
    align: 'left',
    route: {
      path: 'international/:internationalId?',
      element: <International />,
    },
  },
  {
    ignoreMenu: true,
    name: 'View articles',
    route: { path: 'tipping-articles/:id', element: <TippingArticlesView /> },
  },
  {
    name: 'Reset password',
    align: 'left',
    ignoreMenu: true,
    route: { path: 'reset-password/:secretKey', element: <ResetPassword /> },
  },
  {
    name: 'Confirm email',
    align: 'left',
    ignoreMenu: true,
    route: {
      path: 'complete-registration/:mode/:secretKey',
      element: <ConfirmEmail />,
    },
  },
  {
    name: 'Create Account',
    ignoreMenu: true,
    align: 'left',
    privateRoute: true,
    route: { path: 'create-account', element: <CreateAccount /> },
  },
  {
    name: 'Create Account',
    ignoreMenu: true,
    align: 'left',
    privateRoute: true,
    route: {
      path: 'create-account-success',
      element: <AccountCreatedSuccessfully />,
    },
  },
  {
    privateRoute: true,
    name: 'Profile Edit',
    ignoreMenu: true,
    align: 'left',
    route: { path: 'profile-edit', element: <ProfileEdit /> },
  },
  {
    privateRoute: true,
    align: 'right',
    icon: <UserOutlined style={{ fontSize: 18, marginLeft: '5px' }} />,
    name: 'Profile',
    className: 'icon-padding-mini-sub',
    children: [
      {
        privateRoute: true,
        name: 'Profile',
        route: { path: 'profile', element: <Profile /> },
      },
      {
        privateRoute: true,
        icon: <LogoutOutlined />,
        name: 'Sign out',
        onClick: () => {
          store.dispatch(signOut());
        },
      },
    ],
  },
  {
    name: 'Business View',
    route: { path: 'business/:businessId', element: <Business /> },
  },
  {
    ignoreMenu: true,
    name: 'Privacy Policy',
    route: { path: 'privacy-policy', element: <PrivacyPolicy /> },
  },
  {
    ignoreMenu: true,
    name: 'Terms and Conditions',
    route: { path: 'terms-and-conditions', element: <TermsAndConditions /> },
  },
  {
    ignoreMenu: true,
    name: 'FAQ',
    route: { path: 'faq', element: <FAQ /> },
  },
  {
    ignoreMenu: true,
    name: 'Our Mission',
    route: { path: 'our-mission', element: <OurMission /> },
  },
  {
    ignoreMenu: true,
    name: 'Contact Us',
    route: { path: 'contact-us', element: <ContactUs /> },
  },
];
